import React, {Component} from 'react';
import Loading from '../misc/Loading';
import {NavLink as Link} from 'react-router-dom';

class LeadSchemas extends Component {
  printButtonGroup = () => {
    return (
      <div className='pull-right'>
        {this.props.working && (
          <span>
            <i className='fa fa-spinner fa-pulse fa-fw'></i> Arbeider...&nbsp;
          </span>
        )}
        <Link
          to={'/leadSchemas/new'}
          className='btn btn-success'
          disabled={this.props.working}
        >
          Nytt skjema
        </Link>
      </div>
    );
  };

  printPager() {
    if (!this.props.schemas.length) {
      return;
    }

    if (!this.props.total || this.props.total <= this.props.limit) {
      return;
    }

    const pages = Math.ceil(this.props.total / this.props.limit);
    const offsets = [];

    for (let i = 0; i < pages; i++) {
      offsets.push(i * this.props.limit);
    }

    const lastOffset = offsets[offsets.length - 1];

    if (this.props.total && this.props.total > this.props.limit) {
      return (
        <ul className='pagination'>
          <li className={this.props.offset === 0 || this.props.working ? 'disabled' : ''}>
            <a
              href='#'
              onClick={(e) => {
                e.preventDefault();
                this.props.handleSetOffset(0);
              }}
              aria-label='Previous'
              disabled={this.props.working}
            >
              <span aria-hidden='true'>&laquo;</span>
            </a>
          </li>

          {offsets.map((offset, i) => {
            return (
              <li
                key={`page-${i}`}
                className={this.props.offset === offset ? 'active' : this.props.working ? ' disabled' : ''}
              >
                <a
                  href='#'
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.handleSetOffset(offset);
                  }}
                  disabled={this.props.working}
                >
                  {i + 1}
                </a>
              </li>
            );
          })}

          <li className={this.props.offset + this.props.limit > this.props.total || this.props.working ? 'disabled' : ''}>
            <a
              href='#'
              onClick={(e) => {
                e.preventDefault();
                this.props.handleSetOffset(lastOffset);
              }}
              aria-label='Next'
              disabled={this.props.working}
            >
              <span aria-hidden='true'>&raquo;</span>
            </a>
          </li>
        </ul>
      );
    }
  }

  render() {
    if (this.props.working) {
      return <Loading title='Skjemaer' text='Laster' />;
    }

    if (this.props.schemas) {
      if (this.props.schemas.length !== 0) {
        return (
          <section className='campaign mf-padding-top-20'>
            <ol className='breadcrumb'>
              <li>
                <Link to='/'>Forsiden</Link>
              </li>
              <li className='active'>Skjemaer</li>
            </ol>

            <div className='page-header'>
              {this.printButtonGroup()}
              <h1>Skjemaer</h1>
            </div>

            <div className='row'>
              <div className='col-xs-12'>
                <table className='table table-bordered'>
                  <thead>
                    <tr>
                      <th>Navn</th>
                      <th>Type</th>
                      {/* <th>Merke</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.schemas.map((schema) => {
                      let cls = 'warning';
                      if (schema.published) {
                        cls = 'success';
                        if (schema.updated) {
                          cls = 'info';
                        }
                      } else if (schema.archived) {
                        cls = 'danger';
                      }
                      return (
                        <tr key={schema.id} className={cls}>
                          <td style={{verticalAlign: 'middle'}}>
                            <Link to={`/leadSchemas/${schema.id}`}>{schema.name}</Link>
                          </td>
                          <td style={{verticalAlign: 'middle'}}>
                            {schema.type}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className='text-center'>{this.printPager()}</div>
          </section>
        );
      }
    }
    return (
      <section className='campaign mf-padding-top-20'>
        <ol className='breadcrumb'>
          <li>
            <Link to='/'>Forsiden</Link>
          </li>
          <li className='active'>Skjemaer</li>
        </ol>

        <div className='page-header'>
          {this.printButtonGroup()}
          <h1>Skjemaer</h1>
        </div>

        <div className='alert alert-warning'>
          <p>Fant ingen kampanjer</p>
        </div>
      </section>
    );
  }
}

export default LeadSchemas;
